document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("scrollVideo");

  if (!video) {
    console.error("Video element not found!");
    return;
  }

  video.addEventListener("loadedmetadata", () => {
    console.log("Video metadata loaded! Duration:", video.duration);
    const videoDuration = video.duration || 10;

    function updateVideoProgress() {
      const scrollTop = window.scrollY;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollFraction = scrollTop / scrollHeight;

      if (videoDuration) {
        video.currentTime = videoDuration * scrollFraction;
        console.log("Scrolling... Video time:", video.currentTime);
      }
    }

    window.addEventListener("scroll", updateVideoProgress);
  });
});
